// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap___3IAKY","footer":"footer___2pPsK","header":"header___2jypN","cropper":"cropper___JQXhA","list":"list___16a6_"};